// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"Home_root__3GMAO","cardList":"Home_cardList__3qjov"};